import React, { useState } from 'react';

export default function SucursalSelector({ sucursalesDisponibles = [], sucursalesAsignadas = [], onChange }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch] = useState('');

  // Filtra sucursales disponibles que no estén ya asignadas y coincidan con la búsqueda
  const filteredSucursales = sucursalesDisponibles.filter(
    (s) =>
      !sucursalesAsignadas.some((asig) => asig.id === s.id) &&
      s.nombre_sucursal.toLowerCase().includes(search.toLowerCase())
  );

  // Agrega sucursal seleccionada
  const handleAddSucursal = (sucursal) => {
    const nuevas = [...sucursalesAsignadas, sucursal];
    setDropdownOpen(false);
    setSearch('');
    if (onChange) onChange(nuevas);
  };

  // Elimina sucursal asignada
  const handleRemoveSucursal = (id) => {
    const nuevas = sucursalesAsignadas.filter((s) => s.id !== id);
    if (onChange) onChange(nuevas);
  };

  return (
    <div className="w-full">
      <label className="block text-base font-medium text-gray-700 mb-2">Sucursales asignadas</label>
      <div className="flex flex-wrap gap-2 mb-4">
        {sucursalesAsignadas.length === 0 && (
          <span className="text-orange-500 text-base">No hay sucursales asignadas</span>
        )}
        {sucursalesAsignadas.map((sucursal) => (
          <span
            key={sucursal.id}
            className="inline-flex items-center bg-blue-100 text-blue-800 text-sm rounded-full px-3 py-1 mr-2 mb-2 shadow-sm"
          >
            {sucursal.nombre_sucursal}
            <button
              type="button"
              className="ml-2 text-blue-500 hover:text-red-500 focus:outline-none"
              onClick={() => handleRemoveSucursal(sucursal.id)}
              aria-label={`Eliminar sucursal ${sucursal.nombre_sucursal}`}
            >
              ×
            </button>
          </span>
        ))}
      </div>
      <div className="relative inline-block">
        <button
          type="button"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 focus:outline-none"
          onClick={() => setDropdownOpen((open) => !open)}
        >
          + Agregar sucursal
        </button>
        {dropdownOpen && (
          <div className="absolute z-10 mt-2 w-64 bg-white border border-gray-200 rounded shadow-lg">
            <input
              type="text"
              className="w-full px-3 py-2 border-b border-gray-200 focus:outline-none"
              placeholder="Buscar sucursal..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />
            <ul className="max-h-48 overflow-y-auto">
              {filteredSucursales.length === 0 ? (
                <li className="px-4 py-2 text-gray-400">No hay sucursales disponibles</li>
              ) : (
                filteredSucursales.map((s) => (
                  <li
                    key={s.id}
                    className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                    onClick={() => handleAddSucursal(s)}
                  >
                    {s.nombre_sucursal}
                  </li>
                ))
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
